import React, { Component } from 'react';
import { connect } from "react-redux";
import { updateTagId, projectListingGrid} from "../../actions/DashboardAction";
import {renderHiddenInputField} from '../Layout/FormInputs'
import {stripHtml,truncateText} from "../../utils";
import {API_URL, APP_URL, DEFAULT_PROJECT_IMAGE, NO_IMAGE} from "../../config/config";
import {eventTracking} from "../../actions/UserAction";
import {reactLocalStorage} from "reactjs-localstorage";
import { capitalize } from 'lodash';

class ProjectListing extends Component {

    constructor(props) {
        super(props);
        this.state = {
            projectListing : {}
        };
    }

    /**
     * Just for testing the click even. This will be use for project link
     */

    clickMe = (tagId, tagName) => {
        if(this.props.platform == 'mobile') {
            window.postMessage(tagId, "*");
        } else {
            this.props.onClick(tagId, tagName);
        }
    };

    /**
     * Just for tracking on story title click
     */
    eventTrackings = (eventData) => {
      /* Action tracking */
      let originRoute = document.referrer;
      let destinationRoute = window.location.href;
      let date = new Date();
      let postData = {type: eventData, originRoute: originRoute, destinationRoute: destinationRoute, timestamp: date};
      this.props.eventTracking(postData);
      /* Action tracking */
    }


    /**
     * Just for testing the click even. This will be use for project link
     */

    loadMeMore = (tagId) => {
        this.props.onLoadMoreClick(tagId);
    };

    getTitle = ()=> {
        const tagObj = reactLocalStorage.getObject("tag_click");
        if(!tagObj || !tagObj.tagName) {
            return 'Stories you tagged';
        }
        return `Stories Related to ${capitalize(tagObj.tagName)}`;
    }
    /**
     * Render the component
     * @returns {*}
     */
    render() {
        const projectListing = (this.props.projectListing)?this.props.projectListing:[];
        const showLoadMore = this.props.showLoadMore;
        if(projectListing.length > 0) {
          return (
            <div className="row">
                <div className="medium-12 columns">
                    <h2 className="page-heading text-center">
                        {this.getTitle()} <span className="tooltip-wrapper"><i className="icon-question"></i>
                            <span className="text-center tooltip-box">
                                earthDECKS.org featured stories list below is compiled from your word cloud tags.
                            </span>
                        </span>
                    </h2>
                </div>
                <div className="medium-12 columns">
                    <div className="project-list">
                        <ul className="medium-block-grid-2 small-block-grid-1">
                          {
                              projectListing.map((project, ind)=>{

                                let projectThumbnailPic = project.thumbnail;
                                projectThumbnailPic = (typeof projectThumbnailPic != 'undefined')?(projectThumbnailPic):DEFAULT_USER_IMAGE;

                                return (
                                    <li key={ind}>
                                        <div className="project-item shadow-box">
                                            <div className="project-item-image">
                                                <a href={`/story-detail/${project.storyId}`} onClick={ this.eventTrackings.bind(this, `StorySelected:${project.storyId}`) } >
                                                    <img onError={(e)=>{e.target.src=NO_IMAGE}} src={projectThumbnailPic} />
                                                </a>
                                            </div>
                                            <div className="project-item-content">
                                                <div className="project-item-heading">
                                                    <a href={`/story-detail/${project.storyId}`} onClick={ this.eventTrackings.bind(this, `StorySelected:${project.storyId}`) } >{project.title} </a>
                                                </div>
                                                <div className="project-item-location">
                                                    {truncateText(project.subTitle, 80)}
                                                </div>
                                                {/*<div className="project-item-tag">
                                                    <span className="tag-image"><img src="/assets/images/eathdeck/price-tag.png" /></span>
                                                    <div className="tag-content b">
                                                        {
                                                        project.tags.map((tag, index)=>{
                                                            return <span key={`tag_${index}`}>
                                                            { (index ? ', ' : '') }
                                                                <a onClick={() => this.clickMe(tag.tagId, tag.tagName)} className="first-upper">{tag.tagName}</a>
                                                                { (tag.isTagMore == 1) ? ' ...' : '' }
                                                            </span>;
                                                        })
                                                        }
                                                    </div>
                                                    </div>*/}
                                            </div>
                                        </div>
                                    </li>
                                )
                            })
                        }
                        </ul>
                        {
                            showLoadMore && (
                                <div className="text-center load-more">
                                    <a href="javascript:void(0);" className="btn-primary primary-gradient-bg" onClick={() => this.loadMeMore(this.props.tagId)}>LOAD MORE</a>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
          );
        }
        else {
          return (<div></div>);
        }
    }
}

//export default ProjectListing;

//Map state to props
function mapStateToProps(state, localProps) {
  let returnObj = {};
  if(typeof state.dashboard.projectListing != 'undefined'){
      returnObj.projectListing = state.dashboard.projectListing;
  }
  returnObj.tagId = state.dashboard.tagId
  return returnObj;
}
//Connect action to component
export default connect(mapStateToProps,
    {updateTagId, projectListingGrid, eventTracking}
)(ProjectListing);



// WEBPACK FOOTER //
// ./components/Common/ProjectListing.js